/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

import BankAsClient from '../views/system-log/service-log/BankAsClient.vue';
import MerchantApi from '../views/system-log/service-log/MerchantApi.vue';
import InternalService from '../views/system-log/service-log/InternalService.vue';
import InquiryMerchant from '../views/system-log/service-log/InquiryMerchant.vue';
import BankAsServer from '../views/system-log/service-log/BankAsServer.vue';
import AuditTrailPortalAdmin from '../views/system-log/audit-trail/AuditTrailPortalAdmin.vue';
import AuditTrailPortalMerchant from '../views/system-log/audit-trail/AuditTrailPortalMerchant.vue';
import MobileApiLog from '../views/system-log/service-log/MobileApiLog.vue';
import CallbackApiLog from '../views/system-log/service-log/CallbackApiLog.vue';

import { setBreadcrumb } from './index';

const systemLogRoute = {
  path: '/system-log',
  name: 'System Log',
  meta: {
    title: 'BNI QRIS - System Log',
    appBarTitle: 'System Log',
  },
  component: Parent,
  children: [
    {
      path: '/system-log/audit-trail',
      name: 'Audit Trail',
      meta: {
        title: 'BNI QRIS - Audit Trail',
        appBarTitle: 'Audit Trail',
        breadcrumbs: () => [
          setBreadcrumb('System Log', '/system-log', true),
          setBreadcrumb('Audit Trail', '/system-log/audit-trail'),
        ],
      },
      component: Parent,
      children: [
        { 
          path: '/system-log/audit-trail/audit-trail-portal-admin',
          name: 'Audit Trail Portal Admin',
          meta: {
            title: 'BNI QRIS - Audit Trail Portal Admin',
            appBarTitle: 'Audit Trail Portal Admin',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Audit Trail', '/system-log/audit-trail'),
              setBreadcrumb(
                'Audit Trail Portal Admin',
                '/system-log/audit-trail/audit-trail-portal-admin'
              ),
            ],
          },
          component: AuditTrailPortalAdmin,
        },
        {
          path: '/system-log/audit-trail/audit-trail-portal-merchant',
          name: 'Audit Trail Portal Merchant',
          meta: {
            title: 'BNI QRIS - Audit Trail Portal Merchant',
            appBarTitle: 'Audit Trail Portal Merchant',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Audit Trail', '/system-log/audit-trail'),
              setBreadcrumb(
                'Audit Trail Portal Merchant',
                '/system-log/audit-trail/audit-trail-portal-merchant'
              ),
            ],
          },
          component: AuditTrailPortalMerchant,
        },
      ],
    },
    {
      path: '/system-log/service-log',
      name: 'Service Log',
      meta: {
        title: 'BNI QRIS - Service Log',
        appBarTitle: 'Service Log',
        breadcrumbs: () => [
          setBreadcrumb('System Log', '/system-log', true),
          setBreadcrumb('Service Log', '/system-log/service-log'),
        ],
      },
      component: Parent,
      children: [
        {
          path: '/system-log/service-log/bank-as-client-log',
          name: 'Bank As Client Log',
          meta: {
            title: 'BNI QRIS - Bank As Client Log',
            appBarTitle: 'Bank As Client Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Bank As Client Log',
                '/system-log/service-log/bank-as-client-log'
              ),
            ],
          },
          component: BankAsClient,
        },
        {
          path: '/system-log/service-log/merchant-api-log',
          name: 'Merchant API Log',
          meta: {
            title: 'BNI QRIS - Merchant API Log',
            appBarTitle: 'Merchant API Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Merchant API Log',
                '/system-log/service-log/merchant-api-log'
              ),
            ],
          },
          component: MerchantApi,
        },
        {
          path: '/system-log/service-log/internal-service-log',
          name: 'Internal Service Log',
          meta: {
            title: 'BNI QRIS - Internal Service Log',
            appBarTitle: 'Internal Service Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Internal Service Log',
                '/system-log/service-log/internal-service-log'
              ),
            ],
          },
          component: InternalService,
        },
        {
          path: '/system-log/service-log/inquiry-merchant-log',
          name: 'Inquiry Merchant Log',
          meta: {
            title: 'BNI QRIS - Inquiry Merchant Log',
            appBarTitle: 'Inquiry Merchant Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Inquiry Merchant Log',
                '/system-log/service-log/inquiry-merchant-log'
              ),
            ],
          },
          component: InquiryMerchant,
        },
        {
          path: '/system-log/service-log/bank-as-server-log',
          name: 'Bank As Server Log',
          meta: {
            title: 'BNI QRIS - Bank As Server Log',
            appBarTitle: 'Bank As Server Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Bank As Server Log',
                '/system-log/service-log/bank-as-server-log'
              ),
            ],
          },
          component: BankAsServer,
        },
        {
          path: '/system-log/service-log/mobile-api-log',
          name: 'Mobile API Log',
          meta: {
            title: 'BNI QRIS - Mobile API Log',
            appBarTitle: 'Mobile API Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Mobile API Log',
                '/system-log/service-log/mobile-api-log'
              ),
            ],
          },
          component: MobileApiLog ,
        },
        {
          path: '/system-log/service-log/callback-api-log',
          name: 'Callback Api Log',
          meta: {
            title: 'BNI QRIS - Callback Api Log',
            appBarTitle: 'Callback Api Log',
            breadcrumbs: () => [
              setBreadcrumb('System Log', '/system-log', true),
              setBreadcrumb('Service Log', '/system-log/service-log'),
              setBreadcrumb(
                'Callback Api Log',
                '/system-log/service-log/callback-log'
              ),
            ],
          },
          component: CallbackApiLog ,
        },
      ],
    },
  ],
};
export default systemLogRoute;
